export function getExportFilename(title: string, extension: string) {
  const normalizedTitle = title
    .trim()
    .replace(/[/\\?%*:|"<>]/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 80);

  return `${normalizedTitle || 'dotstorming_wall'}.${extension}`;
}
